export const DOMAIN = 'userDetails';
